// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1KhWU","label":"LabeledBox_label__2AF_Z"};